





















import {Component, Prop, Vue} from "vue-property-decorator";

@Component
export default class Feedback extends Vue {

    @Prop() private plantId!: string;

    private feedback: string = "";

    send() {

    }
}
